import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import translate from '../translate';

function ErrorMessage(props) {
  const {
    t,
    errorMessage: errorMessageParam,
    labelClassName,
    containerClassName,
    styleMessage,
  } = props;
  const errorMessage = useMemo(
    () => errorMessageParam || t('ERROR_FIELD_REQUIRED'),
    [errorMessageParam],
  );
  return (
    <div className={containerClassName}>
      <div className={labelClassName} />
      <span className="has-error" style={styleMessage}>
        {errorMessage}
      </span>
    </div>
  );
}

ErrorMessage.propTypes = {
  t: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  labelClassName: PropTypes.string,
  containerClassName: PropTypes.string,
  styleMessage: PropTypes.shape({}),
};
ErrorMessage.defaultProps = {
  errorMessage: undefined,
  labelClassName: 'col-lg-2 col-sm-12',
  containerClassName: 'row',
  styleMessage: {
    marginLeft: '34px',
  },
};

export default translate(ErrorMessage);
